import { render, staticRenderFns } from "./basicVersion.vue?vue&type=template&id=796d2e3f&scoped=true"
import script from "./basicVersion.vue?vue&type=script&lang=js"
export * from "./basicVersion.vue?vue&type=script&lang=js"
import style0 from "./basicVersion.vue?vue&type=style&index=0&id=796d2e3f&prod&lang=scss&scoped=true"
import style1 from "./basicVersion.vue?vue&type=style&index=1&id=796d2e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d2e3f",
  null
  
)

export default component.exports